import { Box, Button, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import Sidebar from "../sidebar";
import CompanyDetails from "./CompanyDetails";
import Wellbeing from "./Social/Wellbeing";
import HumanRights from "./Social/HumanRights";
import Diversity from "./Social/Diversity";
import Community from "./Social/Community";
import CustomerRelation from "./Social/CustomerRelation";
import Environment from "./Environment";
import SupplyChain from "./Social/SupplyChain";
import download from "../../../../src/assets/images/download.svg";
import Governance from "./Governance";
import { useNavigate } from "react-router-dom";
import ESGBaselineYear from "./ESGBaselineYear";
import { downloadReport } from "./downloadReport";
import style from "./download.css";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Unauthorized from "../../Unauthorized/Unauthorized";
import MainSidebar from "../../../Layout/MainSidebar";

const PageBreak = () => <div className="page-break" />;

const ViewDetails = () => {
  const navigate = useNavigate();
  const reportRef = useRef();

  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="Setup">
        <Box style={{ margin: "2rem 0" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: "1.5rem",
            }}
          >
            <Typography
              sx={{
                fontSize: "28px",
                fontWeight: 600,
                fontStyle: "inter",
                textTransform: "uppercase",
              }}
            >
              Preview Details
            </Typography>
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <Button
                style={{
                  color: "#1C486B",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "10px",
                  border: "1px solid #1C486B",
                }}
                onClick={() => navigate("/preview")}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#1C486B",
                  textTransform: "none",
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontStyle: "inter",
                  borderRadius: "10px",
                }}
                onClick={() =>
                  downloadReport(
                    reportRef,
                    "Initial_Questionnaire.pdf",
                    "Initial Questionnaire"
                  )
                }
              >
                <img
                  src={download}
                  alt="Download"
                  style={{ marginRight: "0.5rem" }}
                />{" "}
                Download
              </Button>
            </Box>
          </Box>
          <div ref={reportRef} className={style.page_break}>
            <CompanyDetails />
            <PageBreak />
            <ESGBaselineYear />
            <PageBreak />
            <Environment />
            <PageBreak />
            <Wellbeing />
            <Diversity />
            <PageBreak />
            <Community />
            <HumanRights />
            <CustomerRelation isEditing />
            <PageBreak />
            <CustomerRelation />
            <SupplyChain />
            <PageBreak />
            <Governance />
          </div>
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ViewDetails;
